import * as React from 'react';
import { TagProps, Tag } from '@chakra-ui/react';

export default function PickerTag(props: TagProps) {
  return <Tag color="blue" {...props} />;
}
